import React, { Component } from 'react';
import Footer from 'components/Footer';
import s from './Politika.scss';

class Politika extends Component {

    render() {
        return (
            <div className={s.Politika}>
                <div className={s.Container}>
                    <h1>
                        ПОЛИТИКА
                        В ОТНОШЕНИИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
                        В ООО "НЕДВЕКС"
                    </h1>
                    <h3>
                        1. Общие положения
                    </h3>
                    <p>
                        1.1. Политика в отношении обработки персональных данных (далее — Политика)
                        направлена на защиту прав и свобод физических лиц, персональные данные которых
                        обрабатывает ООО "НЕДВЕКС" (далее — Оператор).
                        <br/>
                        1.2. Политика разработана в соответствии с п. 2 ч. 1 ст. 18.1 Федерального закона от 27 июля
                        2006 г. № 152-ФЗ «О персональных данных» (далее — ФЗ «О персональных данных»).
                        <br/>
                        1.3. Политика содержит сведения, подлежащие раскрытию в соответствии с ч. 1 ст. 14 ФЗ «О
                        персональных данных», и является общедоступным документом.
                    </p>

                    <h3>
                        2. Сведения об операторе
                    </h3>
                    <p>
                        2.1. Оператор ведет свою деятельность по адресу Краснодарский край, г. Сочи, Морской пер.
                        1/1a.
                        <br/>
                        2.2. Администратор Решетов Роман Анатольевич (телефон +7 (967) 655-6576) назначен
                        ответственным за организацию обработки персональных данных.
                        <br/>
                        2.3. База данных информации, содержащей персональные данные граждан Российской
                        Федерации, находится по адресу: 354000, г. Сочи, пер. Морской 1/1 а.
                    </p>

                    <h3>
                        3. Сведения об обработке персональных данных
                    </h3>
                    <p>
                        3.1. Оператор обрабатывает персональные данные на законной и справедливой основе для
                        выполнения возложенных законодательством функций, полномочий и обязанностей,
                        осуществления прав и законных интересов Оператора, работников Оператора и третьих
                        лиц.
                        <br/>
                        3.2. Оператор получает персональные данные непосредственно у субъектов персональных
                        данных.
                        <br/>
                        3.3. Оператор обрабатывает персональные данные автоматизированным и
                        неавтоматизированным способами, с использованием средств вычислительной техники и
                        без использования таких средств.
                        <br/>
                        3.4. Действия по обработке персональных данных включают сбор, запись, систематизацию,
                        накопление, хранение, уточнение (обновление, изменение), извлечение, использование,
                        передачу (распространение, предоставление, доступ), обезличивание, блокирование,
                        удаление и уничтожение.
                        <br/>
                        3.5. Базы данных информации, содержащей персональные данные граждан Российской
                        Федерации, находятся на территории Российской Федерации
                    </p>

                    <h3>
                        4. Обработка персональных данных клиентов
                    </h3>
                    <p>
                        4.1. Оператор обрабатывает персональные данные клиентов в рамках правоотношений с
                        Оператором, урегулированных частью второй Гражданского Кодекса Российской Федерации
                        от 26 января 1996 г. № 14-ФЗ, (далее — клиентов).
                        <br/>
                        4.2. Оператор обрабатывает персональные данные клиентов в целях соблюдения норм
                        законодательства РФ, а также с целью:
                        <br/>
                        — заключать и выполнять обязательства по договорам с клиентами;
                        <br/>
                        — информировать о новых товарах, специальных акциях и предложениях.
                        <br/>
                        4.3. Оператор обрабатывает персональные данные клиентов с их согласия,
                        предоставляемого на срок действия заключенных с ними договоров. В случаях,
                        предусмотренных ФЗ «О персональных данных», согласие предоставляется в письменном
                        виде. В иных случаях согласие считается полученным при заключении договора или при
                        совершении конклюдентных действий.
                        <br/>
                        4.4. Оператор обрабатывает персональные данные клиентов в течение сроков действия
                        заключенных с ними договоров. Оператор может обрабатывать персональные данные
                        клиентов после окончания сроков действия заключенных с ними договоров в течение срока,
                        установленного п. 5 ч. 3 ст. 24 части первой НК РФ, ч. 1 ст. 29 ФЗ «О бухгалтерском учёте» и
                        иными нормативными правовыми актами.
                        <br/>
                        4.5. Оператор обрабатывает следующие персональные данные клиентов:
                        <br/>
                        — Фамилия, имя, отчество;
                        <br/>
                        — Номер контактного телефона;
                        <br/>
                        — Адрес электронной почты;
                        <br/>
                        — Должность;
                        <br/>
                        — Место работы;
                        <br/>
                        — Фотография;
                        <br/>
                        — Сведения об оказанных услугах.
                    </p>

                    <h3>
                        5. Сведения об обеспечении безопасности персональных данных
                    </h3>
                    <p>
                        5.1. Оператор назначает ответственного за организацию обработки персональных данных
                        для выполнения обязанностей, предусмотренных ФЗ «О персональных данных» и
                        принятыми в соответствии с ним нормативными правовыми актами.
                        <br/>
                        5.2. Оператор применяет комплекс правовых, организационных и технических мер по
                        обеспечению безопасности персональных данных для обеспечения конфиденциальности
                        персональных данных и их защиты от неправомерных действий:
                        <br/>
                        — обеспечивает неограниченный доступ к Политике, копия которой размещена по адресу
                        нахождения Оператора, а также может быть размещена на сайте Оператора (при его
                        наличии);
                        <br/>
                        — во исполнение Политики утверждает и приводит в действие документ «Положение об
                        обработке персональных данных» (далее — Положение) и иные локальные акты;
                        <br/>
                        — производит ознакомление работников с положениями законодательства о персональных
                        данных, а также с Политикой и Положением;
                        <br/>
                        — осуществляет допуск работников к персональным данным, обрабатываемым в
                        информационной системе Оператора, а также к их материальным носителям только для
                        выполнения трудовых обязанностей;
                        <br/>
                        — устанавливает правила доступа к персональным данным, обрабатываемым в
                        информационной системе Оператора, а также обеспечивает регистрацию и учёт всех
                        действий с ними;
                        <br/>
                        — производит оценку вреда, который может быть причинен субъектам персональных
                        данных в случае нарушения ФЗ «О персональных данных»;
                        <br/>
                        — производит определение угроз безопасности персональных данных при их обработке в
                        информационной системе Оператора;
                        <br/>
                        — применяет организационные и технические меры и использует средства защиты
                        информации, необходимые для достижения установленного уровня защищенности
                        персональных данных;
                        <br/>
                        — осуществляет обнаружение фактов несанкционированного доступа к персональным
                        данным и принимает меры по реагированию, включая восстановление персональных
                        данных, модифицированных или уничтоженных вследствие несанкционированного доступа
                        к ним;
                        <br/>
                        — производит оценку эффективности принимаемых мер по обеспечению безопасности
                        персональных данных до ввода в эксплуатацию информационной системы Оператора;
                        <br/>
                        — осуществляет внутренний контроль соответствия обработки персональных данных ФЗ «О
                        персональных данных», принятым в соответствии с ним нормативным правовым актам,
                        требованиям к защите персональных данных, Политике, Положению и иным локальным
                        актам, включающий контроль за принимаемыми мерами по обеспечению безопасности
                        персональных данных и их уровня защищенности при обработке в информационной
                        системе Оператора.
                    </p>

                    <h3>
                        6. Права субъектов персональных данных
                    </h3>
                    <p>
                        6.1. Субъект персональных данных имеет право:
                        <br/>
                        — на получение персональных данных, относящихся к данному субъекту, и информации,
                        касающейся их обработки;
                        <br/>
                        — на уточнение, блокирование или уничтожение его персональных данных в случае, если
                        они являются неполными, устаревшими, неточными, незаконно полученными или не
                        являются необходимыми для заявленной цели обработки;
                        <br/>
                        — на отзыв данного им согласия на обработку персональных данных;
                        <br/>
                        — на защиту своих прав и законных интересов, в том числе на возмещение убытков и
                        компенсацию морального вреда в судебном порядке;
                        <br/>
                        — на обжалование действий или бездействия Оператора в уполномоченный орган по
                        защите прав субъектов персональных данных или в судебном порядке.
                        <br/>
                        6.2. Для реализации своих прав и законных интересов субъекты персональных данных
                        имеют право обратиться к Оператору либо направить запрос лично или с помощью
                        представителя. Запрос должен содержать сведения, указанные в ч. 3 ст. 14 ФЗ «О
                        персональных данных».
                    </p>
                </div>
                <Footer/>
            </div>

        );
    }
}

export default (Politika);



// WEBPACK FOOTER //
// ./src/containers/Politika/Politika.js